import React from 'react';

const EvergreenBanner = () => {
  return (
    <>
      <div
        data-testid="evergreen-banner"
        className="fixed top-0 left-0 right-0 z-[60] shadow-2xl"
        style={{ background: 'linear-gradient(135deg, #D97904 0%, #FF9900 50%, #D97904 100%)' }}
      >
        <div className="max-w-7xl mx-auto px-4 py-3">
          <p className="text-white font-semibold text-sm sm:text-base text-center">
            Trusted IT support, digital marketing, and business automation for companies across Northwest Arkansas — request your free consultation today.
          </p>
        </div>
      </div>

      {/* Spacer to prevent content from hiding under fixed banner */}
      <div className="h-16 sm:h-14"></div>
    </>
  );
};

export default EvergreenBanner;
